import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

@Component({

  selector: 'app-division-total',

  templateUrl: './division-total.component.html',

  styleUrls: ['./division-total.component.css']

})

export class DivisionTotalComponent implements OnInit {

  lst_Report: any = [];

  lst_Search: any = [];

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    // strDehestan: new FormControl(''),

  })

  ngOnInit(): void {

    this.search_Total();

  }

  search_Total = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_Mobile_Count', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12ds3d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Report = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strAbadi?.toString().startsWith(val.value) ||

        el.strDehestan?.startsWith(val.value) ||

        el.strSection?.startsWith(val.value) ||

        el.strTownship?.startsWith(val.value) ||

        el.strState?.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.toString().replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'سرجمع تقسیمات سیاسی.xlsx');
  }

}
